import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

const Cell = ({ label, v, testid }) => (
  <div className="rounded-xl bg-slate-50 p-3" data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className="font-display text-xl font-bold tabular-nums">₹{Number(v?.cost || 0).toFixed(0)}</div>
    <div className="text-[11px] text-slate-500">{v?.calls || 0} calls</div>
  </div>
);

// Surepass wallet spend (live calls only): RC ₹3, DigiLocker ₹3, SMS ₹1.
export const SurepassUsage = () => {
  const [u, setU] = useState(null);
  useEffect(() => { adminApi.get("/surepass/usage").then((r) => setU(r.data)).catch(() => {}); }, []);
  if (!u) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mb-6" data-testid="surepass-usage">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold">Surepass verification spend</div>
        {u.test_mode && <span className="text-[11px] font-semibold rounded-full bg-sky-100 text-sky-800 px-2 py-0.5" data-testid="surepass-test-mode">TEST MODE · {u.test_calls} simulated calls, no charge</span>}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <Cell label="Today" v={u.today} testid="surepass-today"/>
        <Cell label="This month" v={u.month} testid="surepass-month"/>
        <Cell label="Overall" v={u.overall} testid="surepass-overall"/>
      </div>
    </div>
  );
};

export default SurepassUsage;
